import { render } from "./SwitchField.vue?vue&type=template&id=c0d6910c&scoped=true"
import script from "./SwitchField.vue?vue&type=script&lang=js"
export * from "./SwitchField.vue?vue&type=script&lang=js"

import "./SwitchField.vue?vue&type=style&index=0&id=c0d6910c&lang=scss&scoped=true"

import exportComponent from "/Users/xujunfeng/Desktop/project/school/digital_factory_server/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d6910c"]])

export default __exports__